export class StateManager {
    constructor() {
        this.uiState = "idle";
        this.subscribers = [];
    }

    subscribe(callback) {
        this.subscribers.push(callback);
        callback(this.uiState);
        return () => {
            this.subscribers = this.subscribers.filter(cb => cb !== callback);
        };
    }

    notifySubscribers() {
        this.subscribers.forEach(cb => cb(this.uiState));
    }

    setUIState(newState) {
        this.uiState = newState;
        this.notifySubscribers();
    }

    getUIState() {
        return this.uiState;
    }

    showTemplateSelection() {
        this.setUIState("template_selection");
    }

    showDocumentView() {
        this.setUIState("document_focused");
    }

    startEditing() {
        this.setUIState("editing");
    }

    returnToIdle() {
        this.setUIState("idle");
    }

    startExport() {
        this.setUIState("exporting");
    }
}

export const stateManager = new StateManager();
